import ProgressGeneral from "./general";
import ProgressOverTime from "./over-time";
import ProgressWeeklyGoals from "./weekly-goals";
import PatientOverviewHNProgress from 'dashboard/templates/views/Patient/HN/PatientOverviewHNProgress';

const navigationSteps = {
    nextDiscussionStep: {
        PatientRecordProgressStatus: 'PatientRecordProgressGoalSetting',
    },
    prevDiscussionStep: {
        PatientRecordProgressGoalSetting: 'PatientRecordProgressStatus',
    }
}

export default {
    path: 'progress',
    name: 'PatientRecordHNProgress',
    props: navigationSteps,
    component: PatientOverviewHNProgress,
    redirect: { name: 'PatientOverviewHNProgressGeneral' },
    meta: {
        // title: 'Patient Record - Healthy Nutrition - Progress',
        // title: t => `${t('patient.patientRecord')} - ${t('screens.healthyNutritionSettingsScreen', 'app_mobile')} - ${t('journeyProgress.progress')}`,
        // title: 'Healthy Nutrition - Status',
        title: t => `${t('screens.healthyNutritionSettingsScreen', 'app_mobile')} - ${t('journeyBehaviourChangeGoals.status')}`,
    },
    children: [
        ProgressGeneral,
        ProgressOverTime,
        ProgressWeeklyGoals
    ],
};
